import { Injectable } from "@angular/core";
import { HttpInterceptor } from "../interceptors/http-interceptor.service";
import { Globals } from "../globals";
import { PermisoService } from "./permiso.service";
import { Observable } from "rxjs/Observable";
import { Response } from '@angular/http';
import { Producto, ProductoEstado } from "../interfaces/producto";
import { MatSnackBar } from "@angular/material";
import { Imagen } from "../interfaces/imagen";
import { ArchivoProducto } from "../interfaces/archivo-producto";
import { Router } from "@angular/router";
import { GeneralService } from './general.service';

@Injectable()
export class ProductoService {
  tipoOferta: string = '';
  public href: string = "";
  constructor(
    private http: HttpInterceptor,
    private globals: Globals,
    private general: GeneralService,
    private permisoService: PermisoService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) { }

  getTipoOferta() {
    this.tipoOferta = '1';
    return this.tipoOferta;
  }

  eliminarProducto(IdProducto: number): Observable<any> {
    return this.permisoService.getPermisoAction('PRODUCTO-ELIMINAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente'),
              IdProducto: IdProducto
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  crearProducto(producto: Producto): Observable<any> {
    return this.permisoService.getPermisoAction('PRODUCTO-CREAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente'),
              producto: producto
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  editarProducto(producto: Producto): Observable<any> {
    return this.permisoService.getPermisoAction('PRODUCTO-EDITAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente'),
              producto: producto
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getProductos(
    paginado: any = {
      page: 0,
      pageSize: 10
    },
    orden: any = {
      sort: 'descripcion',
      order: 'asc'
    },
    filtros: any = {
      generico: ''
    }
  ): Observable<any> {
    return this.permisoService
      .getPermisoAction('PRODUCTO-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getEstadosProducto(): Observable<any> {
    return this.permisoService.getPermisoAction('ESTADOS-PRODUCTO-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction, JSON.stringify({
              idCliente: localStorage.getItem('idCliente')
            }));
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (response: Response) => {
          var respuesta = response.json();

          if (respuesta.estado) {
            if (respuesta.estado == 1 && respuesta.data) {
              var estadosProducto: ProductoEstado[] = <ProductoEstado[]>[];

              respuesta.data.forEach((estadoProducto) => {
                estadosProducto.push(<ProductoEstado>{
                  IdEstado: estadoProducto.IdEstadoProd,
                  descripcion: estadoProducto.EstadoProdDesc
                });
              });

              return estadosProducto;
            }
          }

          return [];
        });
  }

  subirImagenesProducto(IdProducto: number | string, imagenes: Imagen[]): Observable<any> {
    return this.permisoService.getPermisoAction('PRODUCTO-IMAGEN-GUARDAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente'),
              IdProducto: IdProducto,
              imagenes: imagenes
            }));
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getImagenesProducto(
    paginado: any = {
      page: null,
      pageSize: null
    },
    orden: any = {
      sort: 'orden',
      order: 'asc'
    },
    filtros: any = {
      generico: ''
    }
  ): Observable<any> {
    return this.permisoService
      .getPermisoAction('PRODUCTO-IMAGENES-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  editarImagenesProducto(
    IdProducto: number | string,
    IdDestacada: number | string
  ) {
    return this.permisoService
      .getPermisoAction('PRODUCTO-IMAGENES-EDITAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente'),
              IdProducto: IdProducto,
              IdDestacada: IdDestacada
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  eliminarImagenProducto(IdImagen: number | string): Observable<any> {
    return this.permisoService.getPermisoAction('PRODUCTO-IMAGENES-ELIMINAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente'),
              IdFotoProducto: IdImagen
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  subirArchivosProducto(IdProducto: number | string, archivos: ArchivoProducto[]): Observable<any> {
    return this.permisoService.getPermisoAction('PRODUCTO-ARCHIVO-GUARDAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente'),
              IdProducto: IdProducto,
              archivos: archivos
            }));
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getArchivosProducto(
    paginado: any = {
      page: null,
      pageSize: null
    },
    orden: any = {
      sort: 'orden',
      order: 'asc'
    },
    filtros: any = {
      generico: ''
    }
  ): Observable<any> {
    return this.permisoService
      .getPermisoAction('PRODUCTO-ARCHIVOS-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  eliminarArchivoProducto(IdArchivo: number | string): Observable<any> {
    return this.permisoService.getPermisoAction('PRODUCTO-ARCHIVOS-ELIMINAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente'),
              IdArchivo: IdArchivo
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  editarArchivoProducto(archivo: ArchivoProducto): Observable<any> {
    return this.permisoService.getPermisoAction('PRODUCTO-ARCHIVOS-EDITAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente'),
              archivo: archivo
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }
}
